/**
 * ComposeButton
 *
 * Compose button that opens the ComposeDialog.
 */

import { useState } from 'react';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ComposeDialog } from './ComposeDialog';

interface ComposeButtonProps {
  accountId?: string;
}

export function ComposeButton({ accountId }: ComposeButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button className="w-full gap-2" onClick={() => setOpen(true)}>
        <Pencil className="h-4 w-4" />
        Compose
      </Button>
      <ComposeDialog open={open} onClose={() => setOpen(false)} accountId={accountId} />
    </>
  );
}
